import * as React from "react";

import { ContextPanel } from "@/components/layout/ContextPanel";
import { Sidebar } from "@/components/layout/Sidebar";
import { cn } from "@/lib/utils";

interface ChatLayoutProps {
  children: React.ReactNode;
}

/**
 * Chat-specific 3-pane content (Doc 22).
 *
 * Sits INSIDE AppShell, replaces former `<Shell>` (P2.1-S1 refactor):
 * - TopBar moved to AppShell
 * - PrimarySidebar lives in AppShell (always visible)
 * - This layout owns: Conversations Sidebar (280px) + Chat content + Context (320px)
 *
 * Tablet (≥ 640px): + Conversations Sidebar.
 * Desktop (≥ 1024px): + Context Panel.
 * Mobile (< 640px): chỉ chat content (sidebar slide-in defer cho S5).
 */
export function ChatLayout({ children }: ChatLayoutProps): JSX.Element {
  return (
    <div
      className={cn(
        "flex-1 grid gap-0 min-h-0",
        "grid-cols-1",
        "md:grid-cols-[280px_1fr]",
        "lg:grid-cols-[280px_1fr_320px]",
      )}
    >
      <Sidebar />
      <section className="overflow-hidden flex flex-col min-h-0">
        {children}
      </section>
      <ContextPanel />
    </div>
  );
}
